import {
  Checkbox,
  FormControlLabel,
  makeStyles,
  Typography
} from '@material-ui/core'
import classNames from 'classnames'
import { FC } from 'react'

const useStyles = makeStyles({
  checkbox: {
    textAlign: 'left',
    '& svg': {
      width: '0.9em',
      height: '0.9em'
    },
    '& label span': {
      fontSize: '12px',
      color: '#1D1C1D',
      fontWeight: 500
    },
    '& a': {
      color: 'rgb(102, 102, 102)'
    }
  },
  error: {
    display: 'block',
    marginTop: '-4px',
    fontSize: '11px',
    color: 'red'
  }
})

export const CheckboxField: FC<any> = ({
  label,
  input,
  meta,
  className,
  ...props
}) => {
  const styles = useStyles()
  const combinedClassName = classNames(styles.checkbox, className)

  return (
    <div className={combinedClassName}>
      <FormControlLabel
        control={
          <Checkbox
            checked={!!input.value}
            onChange={input.onChange}
            onBlur={input.onBlur}
            {...props}
          />
        }
        label={label}
      />
      {meta.touched && meta.error && (
        <Typography variant='body1' className={styles.error}>
          {meta.error}
        </Typography>
      )}
    </div>
  )
}
